import { defineMessages } from 'react-intl'

const baseId = 'assessment_view'

export default defineMessages({
  memberDetails: {
    id: `${baseId}.member_details`,
    defaultMessage: 'Member details',
  },
  patientSearch: {
    id: `${baseId}.patient_search`,
    defaultMessage: 'Patients',
  },
  title: {
    id: `${baseId}.title`,
    defaultMessage: 'Assessment',
  },
})
